import { ColumnDef } from "@tanstack/react-table"
import React from "react"
import { Link } from "react-router-dom"
import { LinkColumnDefinition, TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"
import { populateStringVariables } from "../../../../../../utils/string"

export default (columnDefinition: LinkColumnDefinition): Partial<ColumnDef<TableRowData>> => ({
    cell: info => {
        const value = info.getValue() as string

        if (!value) {
            return columnDefinition.dataAttributes?.defaultValue || "-"
        }
            
        if (columnDefinition.dataAttributes.modal) {
            const Component = columnDefinition.dataAttributes.modal
            return Component
                ? (
                    <Component.default data={info.row.original} />
                )
                : (
                    <></>
                )
        }

        if (columnDefinition.dataAttributes.redirect) {
            return (
                <>
                    <Link to={populateStringVariables(columnDefinition.dataAttributes.redirect, info.row.original)}>
                        {value}
                    </Link>
                    {columnDefinition.dataAttributes.secondaryValueKey && (
                        <small className="ml-2">
                            {info.row.original[columnDefinition.dataAttributes.secondaryValueKey]}
                        </small>
                    )}
                </>
            )
        }
        
    }
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/cell-mappers/LinkCellMapper.tsx